import { partners } from "./constants/partners";

const gtmDatalayer: () => { push: (payload: any) => void } = () =>
    (window as any).dataLayer || [];

export const datalayer = {
    init: (payload: { partner: string; partnerType: string }) => {
        gtmDatalayer().push(payload);
    },
    setTransactionId: (transactionId: string) => {
        gtmDatalayer().push({
            transactionID: transactionId,
        });
    },
    initDefault: (payload: any) => {
        datalayer.init({
            partner: payload ? payload.partner : partners.pacifico,
            partnerType: payload ? payload.partnerType : partners.pacifico,
        });
    },
    push: (payload: any) => gtmDatalayer().push(payload),
};
